import { zodResolver } from "@mantine/form";
import { memberDataSchema } from "beitary-shared";
import { z } from "zod";

const editMemberFormSchema = memberDataSchema;

export type EditMemberFormValues = z.infer<typeof editMemberFormSchema>;

export const rules = zodResolver(editMemberFormSchema);
